import { Component } from '@angular/core';
import { PosHttpService } from '../../../services/pos.http.service';
import { FnToasterService, FnUtilService } from 'foundation';
import { ServerHealth } from '../../../modal/entity.modal';

@Component({
  selector: 'app-server-health',
  templateUrl: './server-health.component.html',
  styleUrl: './server-health.component.scss'
})
export class ServerHealthComponent {
[x: string]: any;
   objectHash:ServerHealth ={
     serverStartTime: '',
     hostname: '',
     tomcatVersion: '',
     currentServerTime: '',
     threadCount: 0,
     totalMemory: '',
     usedMemory: '',
     cpuUsagePercentage: 0,
     uptime: '',
     loggedInUserCount :0,
     ipAddress:0
   };

  constructor(private posHttpSvsc : PosHttpService, private toastr : FnToasterService){

  }
  ngOnInit(): void {
    this.getServerHealth();
  }

  // getSwaggerUrl() {
  //   let url = window.location.origin + '/AlertDashboard/swagger-ui/index.html';
  //   window.open(url); 
  // }
  
  // getMonitoring() {
  //   let url = window.location.origin + '/AlertDashboard/monitoring';
  //   window.open(url);
  // }
  
  getSwaggerUrl() {
    let url = window.location.href;
   if (url) {
      url = url.substring(0, url.indexOf('#')) + 'swagger-ui/index.html';
    } else {
      url = url + 'swagger-ui/index.html';
    }
    window.open(url);
  }
  
  getMonitoring() {
    let url = window.location.href;
    if (url) {
      url = url.substring(0, url.indexOf('#')) + 'monitoring';
    } else {
      url = url + 'monitoring';
    }
    window.open(url);
  }
    

  getServerHealth(){
    this.posHttpSvsc.authGet('v1/auth/server-status','server-status').subscribe((resp : any) =>{
      if(resp.isError){
        this.toastr.error(resp.isError);
        return;
      }

      this.objectHash = resp;
      
    })
  }
}
